export const es_ES = {
    "LOADER": {
        "CHECK-PRE-EXISTING-RESPONSE": "Búsqueda de respuestas existentes",
        "INIT-PRE-EXISTING-DISK": "Cargando las respuestas existentes del disco",
        "INIT-PRE-EXISTING-HYBRID": "Cargando las respuestas existentes de Internet",
        "INIT-NEW-RESPONSE": "Inicio de nuevo archivo de respuestas"
    },
    "MODULES": {
        "ADMIN": {
            "HEADLINE": "Menú de supervisores",
            "QUIT-HEADLINE": "Salir",
            "QUIT-EARLY-HEADLINE": "Salir del paquete",
            "LEGEND": {
                "ADMIN": "Administración",
                "IAA": "Adecuaciones inclusivas de evaluación",
                "LOG": "Registro"
            },
            "LABEL": {
                "PAUSE": "Función de pausa para<br> el alumno",
                "FONT": "Fuente accesible alternativa",
                "ZOOM": "Nivel de zoom",
                "COLOR": "Tema de color",
                "VIDEO": "Activación automática del<br> subtitulado de video",
                "RESUME": "¿Solicitar el código de supervisor para reanudar el examen?",
                "REASON": "Motivo",
                "TYPE": "Tipo",
                "EXTRA-TOTAL-TIME": "Total de tiempo adicional en minutos",
                "CANDIDATE-TOTAL-TIME-LABEL": "Tiempo total del alumno:",
                "CANDIDATE-TOTAL-TIME": "{{totalTimeAvailableFormatted }} (han transcurrido {{timeElapsed }}; quedan {{timeLeft}})",
                "NEW-CANDIDATE-TOTAL-TIME-LABEL": "Nuevo tiempo total:",
                "NEW-CANDIDATE-TOTAL-TIME": "{{newTotalTimeAvailableFormatted}}",
                "EXPLANATION": "Explicación",
                "INVIGILATOR-UNLOCK-CODE": "Código de supervisor",
                "COLOR-THEMES": "Colores",
                "EXPLANATION-MIN-CHAR":"({{s}} caracteres como mínimo)",
                "FOCUS_LOST-EXPLANATION": "Explicación",
                "FOCUS_LOST-EXPLANATION-MIN-CHAR": "({{s}} caracteres como mínimo)"
            },
            "REASON-PLACEHOLDER": "Aquí puede escribir una nota explicativa como texto libre.",
            "REASON-PLACEHOLDER-MANDATORY": "Por favor agregue aquí una nota explicativa.",
            "INVIGILATOR_UNLOCK_NOTE": "Introduzca el código de supervisor y haga clic en <strong>Desbloquear</strong>.",
            "ERROR": {
                "UNLOCKFAILED": "No se pudo desbloquear con el código de supervisor proporcionado."
            },
            "EVENTLOG_INVIGILATOR_UNLOCK_SUCCESS": "El supervisor abrió correctamente el menú de supervisores.",
            "EVENTLOG_INVIGILATOR_UNLOCK_FAILED": "Se ha introducido un código de supervisor incorrecto.",
            "EVENTLOG_INVIGILATOR_UNLOCK_EMPTY": "Debe completar este campo.",
            "EVENTLOG_APPLICATION_FOCUS_LOST": "La aplicación se interrumpió durante {{sec}} segundos.",
            "EVENTLOG_APPLICATION_FOCUS_LOST_SHORT": "Focus lost Short {{time}} time for {{sec}} seconds",
            "EVENTLOG_APPLICATION_FOCUS_LOST_OVER_THRESHOLD": "Se ha sobrepasado el limite de perdida de foco {} veces.",
            "EVENTLOG_APPLICATION_FOCUS_LOST_INVIGILATOR_UNLOCK_SUCCESS": "Aplicación interrumpida Código de supervisor correcto",
            "EVENTLOG_APPLICATION_FOCUS_LOST_INVIGILATOR_UNLOCK_FAILED": "Aplicación interrumpida Se ha ingresado un código de supervisor incorrecto.",
            "EVENTLOG_APPLICATION_RESUME_BY_CANDIDATE": "Examen reanudado por el alumno",
            "EVENTLOG_APPLICATION_RESUME_BY_INVIGILATOR": "Examen reanudado por el supervisor",
            "EVENTLOG_EXTRATIME_DEDUCTED": "Se han restado {{deducted}} minutos. El tiempo total adicional es {{minutes}} minutos (nuevo tiempo total: {{new_total_time}}).",
            "EVENTLOG_EXTRATIME_ADD": "Se han agregado {{add}} minutos. El tiempo total adicional es {{minutes}} minutos (nuevo tiempo total: {{new_total_time}}).",
            "EVENTLOG_PAUSE_INVIGILATOR_MENU":"En pausa para dar al supervisor acceso al menú de supervisores",
            "EVENTLOG_PAUSE_BY_INVIGILATOR":"Examen puesto en pausa por el supervisor",
            "EVENTLOG_PAUSE_BY_CANDIDATE":"Examen puesto en pausa por el alumno",
            "EVENTLOG_FINISH_EARLY_BY_INVIGILATOR": "Finalización antes de la hora fijada (supervisor)",
            "EVENTLOG_LEAVE_PACKAGE_BY_INVIGILATOR": "Paquete salido por supervisor",
            "PAUSE": {
                "HEADLINE": "En pausa",
                "CONTENT": [
                    "El examen en pantalla se ha puesto en pausa.",
                    "Es necesario un supervisor para reanudar.",
                    "Para reanudar el examen en pantalla, haga clic en el botón que aparece a continuación."
                ]
            },
            "ENTERED-CHAR":"Se han escrito {{s}} caracteres",
            "ENTERED-CHAR-EMPTY":"Se han escrito 0 caracteres",
            "QUIT-CONTENT": [
                "¿Está seguro de que desea salir? Esto finalizará el examen."
            ],
            "QUIT-EARLY-CONTENT": [
                "ADVERTENCIA. Esta opción debe utilizarse únicamente en caso de que se den problemas técnicos que puedan solucionarse saliendo del paquete y volviendo a iniciar sesión.<br/><br/>",
                "No se generará ni procesará ningún archivo de respuestas, por lo que el alumno podrá volver a iniciar sesión en el paquete y continuar con el examen en el punto en que lo interrumpió.<br/><br/>",
                "Si lo que desea es terminar el examen (porque el alumno ha acabado antes de la hora fijada), haga clic en <strong>Cancelar</strong> y, a continuación, en <strong>Salir del examen</strong>, con lo cual se generará un archivo de respuestas final.<br/><br/>",
                "¿Todavía desea continuar? En caso afirmativo, confirme su decisión haciendo clic en el botón <strong>Salir del paquete</strong>."
            ],
            "QUIT-EARLY-CONTENT-ISSUE":[
                "ADVERTENCIA. Se han producido dificultades técnicas que puedan solucionarse saliendo del paquete y volviendo a iniciar sesión.<br/><br/>",
                "No se generará ni procesará ningún archivo de respuestas, por lo que el alumno podrá volver a iniciar sesión en el paquete y continuar con el examen en el punto en que lo interrumpió.<br/><br/>",
            ],
            "QUIT-EARLY-CONFIRM": "Salir del paquete",
            "MODAL": {
                "HEADLINE": {
                    "CANDIDATE-PAUSE"               : "Pausa",
                    "CANDIDATE-CAN-PAUSE-ACTIVATE"  : "Función de pausa para el alumno (activar)",
                    "CANDIDATE-CAN-PAUSE-DEACTIVATE": "Función de pausa para el alumno (desactivar)",
                    "EXTRA-TIME"                    : "Tiempo adicional",
                    "VIDEO-SUBTITLE-ACTIVATE"       : "Activación automática del subtitulado de video (activar)",
                    "VIDEO-SUBTITLE-DEACTIVATE"     : "Activación automática del subtitulado de video (desactivar)"
                }
            },
            "INACTIVITY-TIMEOUT" : {
                "HEADER": "Desconexión por inactividad",
                "ASSESSMENT-RUNNING":{
                    "CONTENT": [
                        "No ha interactuado con el examen desde hace 10 minutos. Puede <strong>Continuar</strong> o <strong>Restablecer temporizador</strong>. También puede optar por <strong>Finalizar el examen</strong>."
                    ],
                    "FINISH-EARLY": "¿Está seguro de que desea salir? Esto finalizará el examen."
                },
                "ASSESSMENT-EXPIRED":{
                    "CONTENT": "No ha interactuado con el examen desde hace 10 minutos. El examen ha terminado.",
                    "JOURNAL-EXITS":"¿Desea completar el cuestionario?"
                },
                "UNLOCK-INFO":[
                    "Ha elegido restablecer el temporizador desde el momento de la última interacción: <strong>{{s}}</strong>. Para continuar, escriba su código de supervisor y haga clic en <strong>Confirmar</strong>. También puede optar por hacer clic en <strong>Continuar</strong> para regresar al examen.","",""
                ],
                "UNLOCK-INFO-END-EXAM":"Introduzca un código de supervisor para finalizar el examen.",
                "UNLOCK-PLACEHOLDER":"Código de supervisor",
                "RESTART": "Para reanudar el examen desde <strong>{{s}}</strong>, haga clic en <strong>Confirmar reinicio</strong>.",
                "EXPLANATION-PLACEHOLDER": "Aquí puede escribir una nota explicativa opcional.",
                "EXPLANATION": "Explicación",
                "EXPLANATION-MIN-CHAR":"({{s}} caracteres como mínimo)",
                "LOG":{
                    "INACTIVITY-TIMEOUT-START": "Inicio de desconexión por inactividad",
                    "INACTIVITY-TIMEOUT-RESET": "Restablecer temporizador tras desconexión por inactividad",
                    "FINISH-EARLY-BY-INVIGILATOR" : "Finalización antes de la hora fijada (supervisor)"
                }
            }
        },
        "PWA-START": {
            "OPEN": "Abrir",
            "SCAN-QR-CODE": "Escanear código QR",
            "PACKAGE-TYPE-SPECIMEN": "muestra",
            "PACKAGE-TYPE-SCHOOL": "examen en vivo",
            "VALID-FROM-TO": "Válido desde {{valid_from|amDateFormat:'MMMM Do YYYY, HH:mm'}} hasta {{valid_to|amDateFormat:'MMMM Do YYYY, HH:mm'}}",
            "NOT-AVAILABLE": "No disponible",

            "LOADING-ASSESSMENTS": "Cargando evaluaciones...",

            "FIRST-TIME-MESSAGE-1": "Esta es la primera vez que usa esta aplicación. Aún no ha cargado ninguna evaluación.",
            "FIRST-TIME-MESSAGE-2": "Para cargar una evaluación, necesita obtener un código QR para un paquete de evaluación.",
            "FIRST-TIME-MESSAGE-3": "Si tiene un código QR, puede escanearlo haciendo clic en el botón \"Escanear código QR\" a continuación.",

            "NO-ASSESSMENTS": "Actualmente no hay evaluaciones almacenadas.",

            "QR-HEADLINE": "Escanear código QR",
            "QR-CANCEL": "Cancel",

            "DOWNLOADING-ASSESSMENT": "Descargando evaluación...",
            "DOWNLOADED-ASSESSMENT": "Evaluación descargada",
            "UNPACKING-ASSESSMENT": "Descomprimiendo evaluación...",
            "ASSESSMENT-READY": "Evaluación lista",
            "ASSESSMENT-READY-MESSAGE": "La evaluación se ha descargado y descomprimido correctamente.",
            
            "RETRY-DOWNLOAD": "Reintentar descarga",
            "TRY-ANOTHER-QR-CODE": "Probar otro código QR",
            "ERROR-MESSAGE": "Error",
            "ERROR-404": "Paquete de evaluación no encontrado (Error {{error_code}}). Esto puede significar:\n• El código QR ha caducado o no es válido\n• La evaluación aún no está disponible\n• La evaluación ha sido eliminada\n\nSi el problema persiste, contacte a su coordinador.",
            "ERROR-NETWORK": "No se puede conectar al servidor de evaluación. Esto puede significar:\n• Problemas de conectividad de red\n• Problemas de configuración del servidor (CORS)\n• El servidor puede estar temporalmente no disponible\n\nVerifique su conexión a internet e inténtelo de nuevo. Si el problema persiste, contacte con soporte.",
            "ERROR-INVALID-QR": "Formato de código QR no válido. Esto puede significar:\n• El código QR no es un código QR de evaluación IB\n• El código QR está dañado o es ilegible\n• El formato del código QR no es compatible\n\nAsegúrese de escanear un código QR de evaluación IB válido.",
            "ERROR-INVALID-HOST": "Dirección del servidor no válida detectada. Esto puede significar:\n• El código QR apunta a un servidor incorrecto\n• El código QR proviene de un sistema diferente\n\nAsegúrese de usar un código QR proporcionado por el IB.",
            "ERROR-GENERIC": "Error al procesar el código QR ({{error_type}}). Esto puede significar:\n• Puede haber problemas de conectividad de red\n• El servidor puede estar temporalmente no disponible\n\nPor favor, inténtelo de nuevo. Si el problema persiste, contacte con soporte.",
            "ERROR-CAMERA-NOT-READABLE": "Error al acceder a la cámara. Esto puede significar:\n• Otra aplicación está usando la cámara\n• El hardware de la cámara ha encontrado un error\n\nPor favor, cierre otras aplicaciones que puedan estar usando la cámara e inténtelo de nuevo.",
            "ERROR-CAMERA-NOT-ALLOWED": "Acceso a la cámara denegado. Esto puede significar:\n• El acceso a la cámara está bloqueado en la configuración del navegador\n• No se han otorgado los permisos de la cámara\n\nPor favor, verifique la configuración de su navegador y permita el acceso a la cámara.",
            "ERROR-PERMISSION-DENIED": "Permiso denegado. Por favor, permita el acceso a la cámara en la configuración de su navegador.",
            "SCAN-NEW-CODE": "Escanear nuevo código",
            "CLOSE": "Cerrar",

            "ACCESS-BLOCKED-HEADLINE": "Acceso denegado",
            "ACCESS-BLOCKED-NOT_CHROMEOS": "Esta aplicación requiere un dispositivo ChromeOS en modo kiosco. Póngase en contacto con su administrador de TI.",
            "ACCESS-BLOCKED-NOT_KIOSK": "Este dispositivo no está en modo kiosco de ChromeOS. Póngase en contacto con su administrador de TI para verificar la configuración del dispositivo.",
            "ACCESS-BLOCKED-NO_SCHOOL_CODE": "No se ha configurado ningún código de centro en este dispositivo. Póngase en contacto con su administrador de TI.",
            "ACCESS-BLOCKED-INVALID_SCHOOL_CODE": "El código de centro configurado en este dispositivo no es válido para los exámenes. Póngase en contacto con su administrador de TI.",
            "DEV-MODE-NOTICE": "Ejecutándose fuera del modo kiosco de ChromeOS. Esto solo está permitido en modo de desarrollo."
        },
        "WELCOME": {
            "HEADLINE": "Bienvenido a este examen en pantalla del PAI <br />",
            "HEADLINE-MEDIA": "Bienvenido al paquete de audio de Música del Programa del Diploma <br>",
            "ISEXPIRED": "Este paquete ha caducado, era válido hasta el:<br /><strong>{{expire_date|amDateFormat:'LLL'}}</strong>",
            "ISBEGUN": "Este paquete no se puede usar todavía, se podrá abrir a partir de:<br /><strong>{{begin_date|amDateFormat:'LLL'}}</strong>",
            "CONTENT": [
                "<em>Se ha solicitado y obtenido autorización para reproducir contenidos que incluyen materiales propiedad de terceros protegidos por derechos de autor, según sea necesario y en la medida de lo posible. Se ha hecho todo lo razonablemente posible para encontrar a los titulares de los derechos de autor, pero si inconscientemente se han incluido materiales cuyo uso requiere autorización del titular de los derechos de autor, obtendremos con gusto dicha autorización lo antes posible. Todas las marcas o marcas registradas (™ o ®) incluidas se utilizan únicamente con fines ilustrativos, y su uso no implica ninguna afiliación con el IB ni aprobación por parte del IB.</em>",
                "<em>Para fines de evaluación, todas las referencias a materiales de terceras personas se almacenan y publican por separado.<br><br>El IB no se responsabiliza de ningún incidente técnico (o de cualquier otro tipo) que se produzca fuera de su control ni de ninguna pérdida o daño ocasionado como resultado del uso de la plataforma o el acceso a ella desde computadoras personales u equipos ajenos al colegio.</em>"
            ],
            "SECONDARY_ACCESS_CODE": "Ingresar código de acceso secundario",
            "SECONDARY_ACCESS_CODE_ERROR": "El código de acceso ingresado no es válido.",
            "INVIGILATOR_LOGIN": "Inicio de sesión de supervisor"
        },
        "VM-DETECTION": {
          "EVENTLOG-INVIGILATOR-MESSAGE": "Se ha detectado una máquina virtual. Un supervisor ha desbloqueado el examen.",
          "EVENTLOG-INVIGILATOR-UNLOCK-FAILED": "Se ha introducido un código de supervisor incorrecto tras la detección de una máquina virtual.",
          "EVENTLOG-INVIGILATOR-UNLOCK-SUCCESS": "Un supervisor ha desbloqueado el examen tras la detección de una máquina virtual.",
          "EVENTLOG-INVIGILATOR-UNLOCK-WRONG-SUCCESS": "El código de desbloqueo puede ser el código del alumno, pero no el del supervisor.",
          "HEADLINE": "Se ha detectado una máquina virtual.",
          "INFO": "Esto no está permitido.",
          "INPUT-HEADLINE": "Código de supervisor",
          "INVIGILATOR-CODE": "Introduzca el código de supervisor",
          "MESSAGE": "Está intentando ejecutar este examen en una configuración con \"máquina virtual\". Para continuar, es necesario obtener permiso e introducir un código de supervisor.",
          "MODAL-INVIGILATOR-TEXT-LABEL": "Deje el mensaje predeterminado o introduzca uno nuevo",
          "MODAL-MESSAGE": "Si desea permitir que el alumno continúe el proceso utilizando una máquina virtual, introduzca un código de supervisor y haga clic en <strong>Desbloquear</strong>."
        },
        "LOGIN": {
            "HEADLINE": "Desbloquee su examen en pantalla.",
            "HEADLINE-MEDIA": "Desbloquear el paquete de audio de Música",
            "HEADLINE_ENTER_KEY": "Introduzca su información de inicio de sesión.",
            "HEADLINE_ENTER_KEY_EXAMINER": "Ingrese su clave de examinador.",
            "SCHOOL_CODE": "Código del colegio",
            "CANDIDATE_CODE": "Código del alumno",
            "UNLOCK_CODE": "Código de acceso",
            "UNLOCKFAILED": "Se han introducido datos de inicio de sesión incorrectos. Compruébelos e inténtelo de nuevo. Nota: en todos los campos se distingue entre mayúsculas y minúsculas.",
            "CONTENT": [
                "<em>Se ha solicitado y obtenido autorización para reproducir contenidos que incluyen materiales propiedad de terceros protegidos por derechos de autor, según sea necesario y en la medida de lo posible. Se ha hecho todo lo razonablemente posible para encontrar a los titulares de los derechos de autor, pero si inconscientemente se han incluido materiales cuyo uso requiere autorización del titular de los derechos de autor, obtendremos con gusto dicha autorización lo antes posible. Todas las marcas o marcas registradas (™ o ®) incluidas se utilizan únicamente con fines ilustrativos, y su uso no implica ninguna afiliación con el IB ni aprobación por parte del IB.</em>",
                "<em>Para fines de evaluación, todas las referencias a materiales de terceras personas se almacenan y publican por separado.<br><br>El IB no se responsabiliza de ningún incidente técnico (o de cualquier otro tipo) que se produzca fuera de su control ni de ninguna pérdida o daño ocasionado como resultado del uso de la plataforma o el acceso a ella desde computadoras personales u equipos ajenos al colegio.</em>"
            ],
            "EVENTLOG_LOGIN_SUCCESS": "El alumno ha iniciado sesión correctamente.",
            "EVENTLOG_LOGIN_FAILED": "Error al intentar iniciar sesión el alumno.",
            "INVIGILATOR_CODE": "Código de supervisor",
            "EVENTLOG_RELOGIN_HYBRID": "El alumno reanudó el examen tras una interrupción. Respuesta recuperada en línea.",
            "EVENTLOG_RELOGIN_DISK": "El alumno reanudó el examen tras una interrupción"
        },
        "HELLOUSER": {
            "WELCOME": {
                "HEADLINE": "Bienvenido al examen en pantalla de {{taskTitle}}.",
                "USER_INFO": "Le hemos identificado como <strong>{{userInfo_completeName}}</strong>,<br />número de alumno <strong>{{userInfo_candidateNo}}</strong>, fecha de nacimiento <strong>{{userInfo_birthDate}}</strong>.",
                "CONTENT": [
                    "Confirme que los datos son correctos."
                ]
            },
            "INCORRECT": {
                "HEADLINE": "Datos del alumno incorrectos",
                "CONTENT": [
                    "Ha confirmado que usted no es <strong>{{userInfo_completeName}}</strong>, código del alumno <strong>{{userInfo_candidateNo}}</strong>, fecha de nacimiento {{userInfo_birthDate}}.",
                    "Esto significa que introdujo el código del alumno incorrecto.",
                    "<strong>Levante la mano e informe al supervisor de inmediato.</strong> "
                ]
            },
            "PERSONALDETAILS": {
                "HEADLINE": "Ingrese sus datos personales",
                "INPUT": {
                    "FIRSTNAME": {
                        "LABEL": "Nombre",
                        "PLACEHOLDER": "Ingrese su nombre."
                    },
                    "LASTNAME": {
                        "LABEL": "Apellido(s)",
                        "PLACEHOLDER": "Ingrese su(s) apellido(s)."
                    },
                    "SCHOOLCODE": {
                        "LABEL": "Código del colegio",
                        "PLACEHOLDER": "Ingrese su código de colegio."
                    }
                },
                "FAILED": "Complete todos los campos.",
                "SCHOOLCODE_WARNING_TITLE": "Advertencia",
                "SCHOOLCODE_WARNING_BODY": "El uso de un código de colegio incorrecto puede impedir que su respuesta sea identificable o procesable. ¿Está seguro de que desea cambiar el código del colegio?",
                "SCHOOLCODE_WARNING_CONFIRM": "Cambiar el código",
                "SCHOOLCODE_WARNING_CANCEL": "Mantener el actual",
                "SCHOOLCODE_EDIT_BTN": "Editar",
                "SCHOOLCODE_NUMERIC_ERROR": "El código del colegio debe ser numérico",
                "CONTENT": [
                    ""
                ],
                "BTN_SUBMIT": "Enviar"
            },
            "RESUME": {
                "HEADLINE": "Reanude su examen en pantalla.",
                "CONTENT": "Parece que usted ya ha iniciado este examen en pantalla en este computador.<br />Tenga en cuenta que el tiempo que ya ha utilizado para completar el examen en pantalla se le restará de su tiempo disponible.<br><strong>Si piensa que esto es incorrecto, póngase en contacto con su supervisor.</strong>",
                "DIFFERENT_CANDIDATE_HEADLINE": "Datos de respuesta existentes encontrados",
                "DIFFERENT_CANDIDATE_SUBTITLE": "pertenece a un usuario que usó previamente este dispositivo",
                "DIFFERENT_CANDIDATE_CONTENT": "Hay datos de respuesta sin terminar en este dispositivo.<br/>Puede reanudar esta sesión si es suya, o empezar de nuevo para iniciar un nuevo examen.",
                "PREVIOUS_CANDIDATE": "La sesión fue iniciada por: {{name}}",
                "PREVIOUS_CANDIDATE_EMAIL": "La sesión fue iniciada por: {{email}}",
                "CONTINUE_AS": "Continuar como {{name}}",
                "START_OVER": "Eliminar y empezar de nuevo",
                "START_OVER_WARNING_TITLE": "¿Eliminar los datos de respuesta existente?",
                "START_OVER_WARNING_BODY": "Los datos de respuesta existente en este dispositivo se eliminarán permanentemente y se iniciará una nueva sesión. Esta acción no se puede deshacer.",
                "START_OVER_CONFIRM": "Eliminar y empezar de nuevo",
                "BACKUP_FAILED": "No se pudieron respaldar los datos de respuesta anteriores. Inténtelo de nuevo o contacte a un supervisor."
            },
            "CAPTUREEMAIL": {
                "HEADLINE": "Dirección de correo electrónico para los resultados",
                "CONTENT": "Este es un examen de muestra. Proporcione la dirección de correo electrónico donde le gustaría recibir sus resultados de evaluación:",
                "INPUT": {
                    "EMAIL": {
                        "LABEL": "Dirección de correo electrónico",
                        "PLACEHOLDER": "Por favor ingrese su dirección de correo electrónico"
                    }
                },
                "ERROR": "Por favor ingrese una dirección de correo electrónico válida."
            }
        },
        "INSTRUCTIONS": {
            "HEADLINE": "Instrucciones",
            "CONTENT": [
                "<strong>El examen en pantalla aún no ha comenzado.</strong><br /><br />",
                "El tiempo comenzará a correr una vez que haga clic en el botón <strong>Empezar</strong> que aparece a continuación. No haga clic en <strong>Empezar</strong> hasta que no se lo autoricen.<br /><br />",
                "Antes de que comience el examen, se le otorgan cinco minutos para que se familiarice con su estructura. Navegue por el examen y observe la extensión de cada tarea y pregunta. ",
                "Tiene <strong>{{taskTimeFormatted}}</strong> para completar el examen en pantalla.<br /><br />",
                "Hay <strong>{{numSheets}}</strong> preguntas distintas en este examen en pantalla. Cada pregunta puede estar dividida en partes. ",
                "Conteste todas las preguntas en los cuadros de respuesta provistos. ",
                "La puntuación máxima para este examen es <strong>{{totalMarks}} {{marksLabel}}</strong>.<br /><br />",
                "A medida que avance en las preguntas, las respuestas se guardarán automáticamente.<br /><br />",
                "<strong>Cuando finalice el período de {{ taskTimeFormatted }}, ya no podrá contestar ninguna pregunta.</strong>"
            ],
            "IAA_PREFERENCES": "Se han aplicado las siguientes adecuaciones inclusivas de evaluación a su registro de alumno:",
            "EVENTLOG_START": "El alumno ha empezado el examen en pantalla.",
            "MINUTES": "minutos",
            "ASSESSMENT-EXPIRED":"Su tiempo total ha concluido. No se puede iniciar el examen.",
            "SCREEN_RECORDING_STARTING": "Iniciando grabación de pantalla...",
            "SCREEN_RECORDING_ERROR_TITLE": "Grabación de pantalla requerida",
            "SCREEN_RECORDING_PERMISSION_DENIED": "Se denegó el permiso de grabación de pantalla. Debe otorgar el permiso para continuar.",
            "SCREEN_RECORDING_NOT_SUPPORTED": "La grabación de pantalla no es compatible con este navegador.",
            "SCREEN_RECORDING_ALREADY_ACTIVE": "La grabación de pantalla ya está activa.",
            "SCREEN_RECORDING_RESTART_FAILED": "Error al reiniciar la grabación de pantalla. Inténtelo de nuevo.",
            "SCREEN_RECORDING_UNKNOWN_ERROR": "Se produjo un error desconocido al iniciar la grabación de pantalla",
            "SCREEN_RECORDING_PERMISSION_HELP": "Para otorgar permiso de grabación de pantalla:",
            "SCREEN_RECORDING_PERMISSION_STEP1": "Haga clic en el botón 'Intentar de nuevo' a continuación",
            "SCREEN_RECORDING_PERMISSION_STEP2": "Cuando se le solicite, seleccione 'Pantalla completa' o su pantalla específica",
            "SCREEN_RECORDING_PERMISSION_STEP3": "Haga clic en 'Compartir' para otorgar el permiso",
            "SCREEN_RECORDING_NOT_SUPPORTED_HELP": "Utilice un navegador compatible (Chrome, Firefox, Edge) que admita grabación de pantalla.",
            "SCREEN_RECORDING_RETRY": "Intentar de nuevo",
            "SCREEN_RECORDING_MANDATORY": "La grabación de pantalla es obligatoria para este examen.",
            "SCREEN_RECORDING_CONTACT_ADMIN": "Póngase en contacto con su administrador de examen para obtener ayuda."
        },
        "TASKDONE": {
            "HEADLINE": "El examen ha terminado.",
            "INSTRUCTIONS": "<strong>No intente cerrar sesión, apagar ni sacar el computador.</strong><br/><br/>Siga cualquier otra instrucción del supervisor.",
            "PACK-RESPONSE": "Obteniendo los datos y preparando el archivo de respuestas",
            "UPLOADING-RESPONSE": "Cargando el archivo de respuestas",
            "ATTEMPT": "Intentar",
            "UPLOAD-SUCCESS": "El archivo de respuestas se ha cargado correctamente. Puede salir del paquete de examen.",
            "UPLOAD-PENDING": "Aún no se ha enviado el archivo de respuestas al IB.",
            "UPLOAD-FAILED": "Se ha producido un problema al cargar el archivo de respuestas. Inténtelo de nuevo.",
            "RETRYING-UPLOAD": "La carga ha fallado. Reintentando automáticamente...",
            "PACK-FAILED": "Error al empaquetar los datos de respuesta. Sus datos han sido guardados y pueden ser recuperados. Por favor, contacte a su supervisor.",
            "RETRY-UPLOAD": "Reintentar carga",
            "TRY-UPLOAD": "Intentar cargar el archivo de respuestas",
            "EXIT": "Salir",
            "SAVE-TO-FS": "El archivo de respuestas no se ha cargado automáticamente. Puede hacer clic otra vez en <strong>Intentar cargar el archivo de respuestas</strong> o en <strong>Salir</strong> y enviar el archivo de respuestas manualmente. El archivo de respuestas se encuentra en la carpeta Documentos de este dispositivo.",
            "SAVE-TO-FS-BUTTON": "Copiar el archivo de respuestas en una carpeta distinta",
            "DP-MEDIA":{
                "HEADLINE": "El examen ha terminado.",
                "INFO":"El examen ha terminado.<br/<br>Escuche al supervisor del examen, que le proporcionará instrucciones adicionales.<br/>Esta aplicación se cerrará automáticamente después de 30 segundos."
            }
        },
        "NAVBAR": {
            "SELECT-KEYBOARD-LANG": "Teclado (lengua)",
            "HIGHLIGHT-TOOL": "Herramienta para resaltar",
            "CALCULATOR": "Calculadora",
            "DIRECTIVE": {
                "BOOKMARKED": "Preguntas<br />marcadas"
            },
            "DIRECTIVEINSTRUCTIONSLONG": "<h4>Información general</h4>    <p>        Conteste todas las preguntas en el tiempo asignado. Si tiene algún problema durante el examen, levante la mano e informe al supervisor.    </p>  <h4>Navegación</h4>    <p>        <b>Vistas previas de las preguntas</b><br /> La pantalla de inicio muestra una vista previa de todas las preguntas del examen. Al hacer clic en cualquier parte de la vista previa, se abrirá la pregunta completa.<br /><br /> La pregunta completa contiene más información que la vista previa. Asegúrese de leer todo el material antes de responder.     </p>    <p>     <b>Menú de la derecha</b><br /> El lado derecho de la pantalla contiene un menú que muestra una lista de todas las preguntas del examen.<br /><br /> Al hacer clic en el número de una pregunta, esta se abrirá para mostrar de cuántas partes consta. Luego, al hacer clic en cualquiera de las partes, se mostrará la pregunta en la ventana principal.    </p>  <h4>Estados</h4>    <p>        Hay tres estados en los que puede estar una pregunta:    </p><ul><li>Sin empezar</li><li>En curso</li><li>Completada</li></ul> Cuando inicie el examen, todas las preguntas se encontrarán en el estado \"Sin empezar\". En cuanto empiece a contestar una pregunta, el sistema cambiará automáticamente el estado de esa pregunta a \"En curso\".  Una vez que salga de la pregunta, el estado cambiará a \"Completada\" (después siempre podrá volver y modificar su respuesta si necesita hacerlo).<br /><br />   <p><br /></p>",
            "DIRECTIVEINSTRUCTIONSLONG-MEDIA": "<h4>Información general</h4><p>Si tiene algún problema, informe al supervisor de su examen.</p><p><br></p>",
            "DIRECTIVEINSTRUCTIONS": {
                "GENERAL": {
                    "HEADLINE": "Généralité",
                    "CONTENT": ""
                },
                "NAVIGATION": {
                    "HEADLINE": "Navigation",
                    "CONTENT": [
                        "<b>Aperçu des questions</b><br />L’espace principal de l’écran d’accueil présente un aperçu de toutes les questions de l’évaluation. En cliquant sur l’aperçu d’une question, vous ouvrirez la question complète.<br /><br />La question complète comprendra plus d’information que son aperçu. Veillez donc à bien lire tout le contenu avant de répondre à une question.",
                        "<b>Menu à droite de l’écran</b><br />Vous trouverez à droite de l’écran un menu contenant une liste de toutes les questions de l’évaluation.<br /><br />Cliquer sur le numéro d’une question en révèlera les parties. Cliquer sur une partie vous amènera au début de la question."
                    ]
                },
                "STATUSES": {
                    "HEADLINE": "Statuts",
                    "CONTENT": [
                        "Chaque question peut avoir l’un des trois statuts suivants:<ul><li>Non commencée</li><li>Commencée</li><li>Terminée</li></ul>Lorsque vous commencerez l’évaluation, toutes les questions auront \"Non commencée\" comme statut. Dès que vous commencerez à répondre à une question, son statut passera à \"Commencée\". Une fois que vous êtes satisfait(e) de votre réponse, vous pouvez en changer le statut et la marquer comme \"Terminée\" (vous pouvez toutefois à tout moment y revenir et modifier votre réponse si vous le souhaitez).<br /><br />La barre de progression vous donne un aperçu de votre progression dans l’évaluation en vous indiquant le statut des différentes questions."
                    ]
                }
            },
            "DIRECTIVEQUIT": {
                "HEADLINE": "Confirme, por favor.",
                "CONTENT": "¿Realmente desea salir? Esto finalizará el examen."
            },
            "FINISH-EARLY": {
                "HEADLINE": "Advertencia. Finalización antes de la hora fijada",
                "LABEL": {
                    "LASTNAME": "Apellidos",
                    "FIRSTNAME": "Nombre"
                },
                "TOOLTIP": {
                    "DISABLED-FINISH-EARLY-BTN": "Solo estará disponible después de 60 minutos."
                },
                "WARNING-CONTENT": [
                    "Ha seleccionado la opción de finalizar el examen antes de la hora fijada.",
                    " Si continúa, el examen se dará por terminado y ya no podrá regresar a él.",
                    "¿Todavía desea finalizar el examen antes de la hora fijada?"
                ],
                "CONFIRM-CONTENT": [
                    "Ha confirmado que desea finalizar este examen antes de la hora fijada.",
                    "Para proseguir, escriba su nombre a continuación y haga clic en <strong>Finalizar antes de la hora fijada</strong>. Aún puede optar por cancelar este proceso y regresar al examen."
                ],
                "JOURNAL-EXITS": "¿Desea completar el cuestionario?"
            }
        },
        "SIDEBAR": {
            "HEADLINE": "Mapa de estado",
            "TOOLTIP": {
                "COMPLETE": "Marcada como completada",
                "COMPLETED": "Completada",
                "NOTSTARTED": "Sin empezar",
                "PARTLY-COMPLETED": "En curso"
            },
            "BUTTONS":{
                "SCROLL-UP": "Pregunta anterior",
                "SCROLL-DOWN": "Siguiente pregunta"
            }
        },
        "QUESTION": {
            "HINTOPTION": "Opción Pista",
            "BACKTOOVERVIEW": "Volver a la vista general de la pregunta"
        },
        "JOURNAL": {
            "HEADLINE": "Cuestionario",
            "CONTENET": [
                "El examen ha finalizado. A continuación puede realizar un cuestionario de reflexión <strong>opcional</strong> de 10 minutos. Utilice el cuestionario de reflexión para reflejar su experiencia relativa a la preparación y realización del examen. ¿Desea completar el cuestionario?"
            ],
            "CONFIRM-SAVE": "¿Está seguro de que desea completar su cuestionario?"
        },
        "SHEET": {
            "READING-TIME": {
                "MODAL": {
                    "HEADLINE": "Tiempo de lectura",
                    "CONTENT": [
                        "El tiempo de lectura ha acabado y el examen en pantalla está listo para empezar. Para continuar, haga clic en el botón <strong>Empezar</strong>."
                    ]
                },
                "OVERLAY": {
                    "LABEL": "Tiempo de lectura"
                }
            }
        },
        "CHANGELANGUAGE":{
            "LABEL": "Seleccionar la lengua del sistema",
            "LANGUAGES":{
                "EN": "English",
                "ES": "Español",
                "FR": "Français"
            }
        },
        "WIRIS-CKEDITOR-PLUGIN": {
          "BTN-CANCEL": "Cancelar",
          "BTN-OK": "Confirmar (insertar ecuación)",
          "OVERLAY-MSG": "Introduzca su ecuación a continuación y haga clic en <i>Confirmar (insertar ecuación)</i>.",
          "SHEET-LEAVE-MSG": "Ha introducido una ecuación en {{s}}, pero no la ha confirmado. ¿Está seguro de que desea descartar la ecuación? No se incluirá en su respuesta.",
          "SHEET-LEAVE-TITLE": "Editor de ecuaciones"
        },
        "SHEET-LEAVE":{
            "MODAL":{
                "HEADLINE":"Advertencia",
                "BTN":{
                    "CANCEL": "Volver a la pregunta",
                    "CONFIRM": "Salir de la pregunta"
                }
            }
        }
    },
    "BTN": {
        "PAUSE": "Pausa",
        "CANDIDATE-PAUSE": "Pausa",
        "CARRY-ON": "Continuar",
        "BACK": "Volver",
        "UNLOCK": "Desbloquear",
        "CORRECT": "Correcto",
        "QUIT": "Salir",
        "QUIT-APP": "Salir de la aplicación",
        "QUIT-EARLY-ASSESSMENT": "Salir del examen",
        "QUIT-ASSESSMENT": "Salir del paquete",
        "SUBMIT": "Enviar",
        "CONTINUE": "Continuar",
        "START": "Empezar",
        "ADMIN_MENU": "Menú de supervisores",
        "INVIGILATOR": "Supervisor",
        "ASSISTANCE": "Ayuda",
        "INSTRUCTIONS": "Instrucciones",
        "BOOKMARKS": "Marcadores",
        "OK": "Aceptar",
        "CANCEL": "Cancelar",
        "BACKGROUNDRESOURCE": "Recursos de contexto",
        "CLOSE": "Cerrar",
        "PRE-RELEASE": "Material general de ayuda",
        "EXTRA-TIME": "Tiempo adicional",
        "RECORD-INCIDENT": "Registrar<br> incidente",
        "CONFIRM-PAUSE": "Confirmar",
        "CONFIRM-EXTRA-TIME": "Confirmar",
        "CONFIRM-INCIDENT": "Confirmar el registro del incidente",
        "UNLOCK-ASSESSMENT": "Reanudar examen",
        "RESUME-ASSESSMENT": "Reanudar examen",
        "INVIGILATOR-ACCESS": "Acceso del supervisor",
        "RESUME": "Reanudar",
        "RETRY-UPLOAD": "Reintentar carga",
        "YES": "Sí",
        "NO": "No",
        "SAVE": "Guardar",
        "CONFIRM": "Confirmar",
        "END-ASSESSMENT": "Finalizar el examen",
        "FINISH-EARLY": "Finalizar antes de la hora fijada",
        "GOTO-JOURNAL": "Abrir el cuestionario",
        "RESET-TIME": "Restablecer temporizador",
        "RESTART": "Confirmar reinicio"
    },
    "CONTENT": {
        "COPYRIGHT_TEXT": "© Organización del Bachillerato Internacional, {{year}}. Todos los derechos reservados.",
        "SCROLLINFO": "Desplácese hacia abajo para continuar.",
        "PROCESSING": "Procesando",
        "MARK": "punto{{totalMarks > 1 && 's' || ''}}"
    },
    "BACKGROUND": {
        "TAB": {
            "READING": "Lectura",
            "VIDEO": "Video"
        }
    },
    "SYSTEM": {
        "CLOCK": {
            "REMAINING": "Restante",
            "ELAPSED": "Transcurrido",
            "NONE": "Ocultar reloj",
            "HOURS": "horas",
            "HOUR": "hora",
            "MINUTES": "minutos",
            "MINUTE": "minuto",
            "SECONDS": "segundos",
            "SECOND": "segundo",
            "PAUSED": " (pausa)"
        },
        "SAVEINDICATOR": {
            "SAVING": "Guardando...",
            "SAVED": "Respuestas guardadas"
        },
        "FOCUSLOST": {
            "TITLE": "Aplicación interrumpida",
            "WARNING": "El sistema ha detectado que se interrumpió el examen o se intentó salir del examen. ",
            "LOGGED": "Esto ha quedado registrado en su archivo de respuestas.",
            "ALTERNATIVE": {
                "TITLE": "Aplicación interrumpida",
                "WARNING": "Se ha interrumpido la sesión. Sin embargo, no tiene nada que hacer y puede continuar con su examen."
            }
        }
    },
    "TOOLTIPS": {
        "BOOKMARKBTN": "Mostrar preguntas marcadas",
        "ISBOOKMARKED": "Desmarcar esta pregunta",
        "ISNOTBOOKMARKED": "Marcar esta pregunta",
        "FLAGASCOMPLETE": "Marcar como completada",
        "FLAGASUNCOMPLETE": "Marcar como incompleta"
    },
    "VIDEOPLAYER": {
        "FULLSCREEN": "Alternar pantalla completa",
        "POSTROLLCLOSE": "Cerrar",
        "PLAYPAUSE": "Reproducir/Pausa",
        "MUTE": "Alternar silencio",
        "STOP": "Detener",
        "SUBTITLE_ON": "Activar subtítulos",
        "CAPTION": "Subtítulos",
        "CAPTION_NONE": "Ninguno"
    },
    "IAA": {
        "iaa": "AIE",
        "allegedAcademicMisconduct": "Presunta conducta improcedente",
        "disruptionToExam": "Interrupción del examen",
        "pause": "Examen puesto en pausa por el supervisor",
        "resumeByInv": "Examen reanudado por el supervisor",
        "resumeByCand": "Examen reanudado por el alumno",
        "extratime": "Tiempo adicional asignado al alumno por el supervisor",
        "genericNote": "Nota genérica/otro incidente",
        "loginSuccess": "Inicio de sesión correcto",
        "loginFailed": "Error de inicio de sesión",
        "invLoginSuccess": "Inicio de sesión correcto",
        "invLoginFailed": "Error de inicio de sesión",
        "assessmentStart": "Examen en curso",
        "resume": "Se ha reanudado el examen.",
        "fireAlarm": "Alarma de incendio",
        "anyOther": "Cualquier otro motivo",
        "toiletBreak": "Descanso para ir al baño",
        "candidateCanPause": "Función de pausa para el alumno",
        "extraTime": "Tiempo adicional",
        "dyslexicFont": "Fuente accesible alternativa",
        "zoomLevel": "Nivel de zoom",
        "colorTheme": "Color de tema",
        "extraTimeInfo": "Tiempo total del alumno: {{ totalTimeAvailable }}, han transcurrido {{ timeElapsed }}, quedan {{ timeLeft }}",
        "videoSubtitleAutoEnable": "Activación automática del subtitulado de video",
        "activated": "Activado '{{key}}'",
        "deactivated": "Desactivado '{{key}}'",
        "changedValue": "Configuración de '{{key}}' cambiada de '{{oldVal}}' a '{{newVal}}'.",
        "changedValueNoPreviousValue": "Configuración de '{{key}}' cambiada a '{{newVal}}'.",
        "examinationAdministrationIssue": "Problema con la administración del examen",
        "candidateIllness": "Enfermedad",
        "candidateIllnessTemporaryMedicalCondition": "Enfermedad o afección médica temporal del alumno",
        "extremeWeatherCondition": "Condiciones meteorológicas extremas",
        "inclusiveAssessmentArrangements": "Adecuaciones inclusivas de evaluación",
        "misconductDuringExamination": "Conducta improcedente durante el examen",
        "unauthorizedMaterialInExamination": "Introducir material no autorizado en la sala de examen",
        "unethicalPractice": "Prácticas no éticas",
        "multipleResponseFiles": "Varios archivos de respuestas",
        "finishEarlyByCandidate": "Finalización antes de la hora fijada (alumno)",
        "finishEarlyByInvigilator": "Finalización antes de la hora fijada (supervisor)",
        "focusLost": "Application focus lost",
        "focusLostAlternative": "Application focus lost",
        "leavePackageEarlyByInvigilator": "Paquete salido por supervisor",
        "alternativeContent":  "Contenido alternativo",
        "alternativeContents": {
            "visuallyImpaired": "discapacidad visual"
        },
        "assessmentReStartHybrid": "Volver a iniciar sesión en línea",
        "assessmentReStartDisk": "Volver a iniciar sesión",
        "responseFileBlank": "Respuesta en blanco"
    },
    "CONTENTOBJECT": {
        "RESPONSE-SHORT-TEXT": {
            "LABEL": ""
        },
        "TABEL": {
            "NEXT-STEP": "Siguiente paso",
            "RESET": "Restablecer",
            "ALIGNMENT": "Alineación",
            "STEP1": "Primer paso",
            "STEP2": "Segundo paso",
            "STEP3": "Tercer paso",
            "ROWS": "Filas",
            "COLS": "Columnas",
            "LOCKED": "Bloqueado",
            "TABLE-SIZE": "Tamaño de la tabla",
            "TABLE-DATA": "Datos de la tabla",
            "HELPTEXT-1": "Elija la alineación de su tabla: <strong>Horizontal</strong> (encabezados de fila a la izquierda) o <strong>Vertical</strong> (encabezados de columna en la parte superior)",
            "HELPTEXT-2": "Elija el número de filas y columnas de su tabla (podrá agregar o eliminar filas y columnas más tarde).",
            "HELPTEXT-3": "Ingrese los datos en la tabla (incluidos los encabezados).",
            "CTX-MENU": {
                "READ-ONLY": "Solo lectura",
                "REMOVE-ROW": "Eliminar fila",
                "REMOVE-COL": "Eliminar columna",
                "ROW-ABOVE": "Fila en la parte superior",
                "ROW-BELOW": "Fila en la parte inferior",
                "COL-LEFT": "Columna a la izquierda",
                "COL-RIGHT": "Columna a la derecha",
                "MERGE-CELLS": "Combinar celdas",
                "UNMERGE-CELLS": "Separar celdas",
                "FORMAT-AS-HEADER-ROW": "Dar formato como encabezado<br>de fila",
                "FORMAT-AS-HEADER-COLUMN": "Dar formato como encabezado<br>de columna",
                "SET-AS-HEADER-CELL": "Fijar como celda de encabezado",
                "UNSET-AS-HEADER-CELL": "Quitar celda de encabezado",
            },
            "CREATE-NEW-TABLE-OBJECT": "Crear nueva tabla",
            "CREATE-TABLE-SIZE": "Crear tabla con {{cols}} columnas y {{rows}} filas"
        },
        "IAA-CONTAINER": {
            "ADD-NEW-BTN": "Add IAA-Container",
            "FILTER-BTN": "Show: ",
            "FILTER-BTN-PREVIEW": "IAA-Content: ",
            "IAA-CONTAINER": {
                "all": "All",
                "default": "Default",
                "visuallyImpaired": "Visually Impaired"
            },
            "WARNING-MESSAGES":{
                "IS-DEFAULT":"Falling back to the default section for this IAA Container",
                "IAA-CONTAINER-NOT-EXISTS": "'{{s}}' section does not exist!",
                "IAA-OBJECTS-NOT-EXISTS": "No object defined in '{{s}}' section!"
            }
        },
        "CAROUSEL": {
            "LOADING": "Cargando carrusel..."
        },
        "RESPONSETEXTBOX": {
            "HIGHLIGHT": "Resaltar",
            "QUESTION-HIGHLIGHT": "Question highlight",
            "IMAGE-FROM-CALC": "Imagen de la calculadora",
            "LAODING":"Cargando ...",
            "LOADING-FAILED":"No se puede cargar el texto enriquecido. Por favor llame al supervisor.",
            "ERRORS":{
                "UNLOADED":{
                    "HEADLINE":"Se ha producido un error",
                    "MESSAGE":"No se puede cargar el texto enriquecido.<br>Por favor llame al supervisor.<br><strong>{{errorMessage}}</strong>"
                }
            }
        },
        "TAB": {
            "LOADING": "Cargando fichas..."
        },
        "IFRAME": {
            "CONTENT": [
                "<p><strong>Marcador de contenido IFrame</strong><br />Se ha seleccionado contenido Iframe y se mostrará solo en modo de vista previa.<br />No obstante, este cuadro presenta las dimensiones seleccionadas.</p>",
                "<p><strong>Marcador de contenido IFrame</strong><br />No se ha seleccionado aún ningún contenido IFrame.<br />Use el botón \"Examinar Biblioteca multimedia\" para seleccionar contenido IFrame (ya cargado).</p>"
            ]
        },
        "HINT": {
            "TITLE": "Pista ",
            "EXPLANATION": "Si la acepta, esta pista mostrará información útil.<br/><strong> Si acepta la pista, ya no podrá obtener {{marks}} puntos.</strong>",
            "EXPLANATION2":"¿Seguro que desea aceptar esta pista?<br/><strong> No podrá obtener {{marks}} puntos por esta pregunta.</strong>",
            "CONFIRM1": "Entiendo.",
            "CANCEL1": "Cancelar",
            "CONFIRM2": "Deme una pista.",
            "CANCEL2": "Cancelar",
            "TAKEN": "PISTA ACEPTADA. Puntos relacionados que ya no se podrán obtener: {{marks}}",
            "TAKEN-PDF": "NIVEL DE PISTA {{level}} ACEPTADO. Reste {{marks}} punto(s).",
            "TOTAL-TAKEN-PDF": "NIVEL DE PISTA {{levels}} ACEPTADO. Reste {{marks}} punto(s)."
        },
        "SCATTERGRAPH": {
            "GRAPH-SETTINGS": "Configuración de la gráfica",
            "OPEN-GRAPH-SETTINGS": "Abrir configuración de la gráfica",
            "GRAPH-TITLE": "Título de la gráfica",
            "X-LABEL": "Rótulo del eje X",
            "Y-LABEL": "Rótulo del eje Y",
            "X-DECIMALS": "Número de lugares decimales mostrados (eje X)",
            "Y-DECIMALS": "Número de lugares decimales mostrados (eje Y)",
            "X-MINIMUM": "Eje X: valor mínimo ",
            "Y-MINIMUM": "Eje Y: valor mínimo ",
            "X-INCREMENT": "Eje X: incremento/escala",
            "Y-INCREMENT": "Eje Y: incremento/escala",
            "CLOSE": "Cerrar",
            "SAVE-CHANGES": "Aplicar cambios",
            "LINE-TOOL": "Dibujar línea",
            "RECTANGLE-TOOL": "Situar punto azul",
            "CIRCLE-TOOL": "Situar punto blanco",
            "DIAMOND-TOOL": "Situar punto rojo",
            "TRIANGLE-TOOL": "Situar punto verde",
            "POLYGON-TOOL": "Situar punto amarillo",
            "LABEL-OUTLIER": "Identificar un valor atípico",
            "LABEL-REGION": "Identificar una región",
            "INSTRUCTIONS-LABEL": "Instrucciones",
            "INSTRUCTIONS-TEXT": "Haga clic en \"EMPEZAR\" para comenzar a trazar la gráfica.",
            "INSTRUCTIONS-BUTTON": "EMPEZAR",
            "X-DEFAULT-LABEL": "Rótulo del eje x",
            "Y-DEFAULT-LABEL": "Rótulo del eje y",
            "DEFAULT-TITLE": "Título",
            "REGION": "región",
            "OUTLIER": "valor atípico"
        }
    },
    "PREFIX": {
        "QUESTION": "Pregunta",
        "QUESTION-PART": "Pregunta",
        "PRE-RELEASE": "Material general de ayuda",
        "JOURNAL": "Cuestionario"
    },
    "AUTOPLOT": {
        "OPENWIZARD": "Abrir el asistente para gráficos",
        "SCATTER": "Dispersión",
        "BAR": "Barras",
        "PIE": "Sectores",
        "SELECTIONMODE-INFOTEXT": {
            "FULL": "Haga clic en el encabezado de columna o fila para seleccionar {{axis}} en {{series}}.",
            "FIELDS": "Haga clic y mantenga presionado el botón para seleccionar datos para {{axis}}.",
            "FIELDS_SERIES": "Haga clic y mantenga presionado el botón para seleccionar datos para {{axis}} en {{series}}."
        },
        "CHARTSETTINGS": {
            "TITLE": "Título del gráfico",
            "TITLE-PLACEHOLDER": "Escriba aquí el título del gráfico.",
            "LABELS": "Rótulos",
            "SELECT-LABELS": "Seleccionar rótulos",
            "LABELS-PLACEHOLDER": "Seleccione los rótulos.",
            "VALUES": "Valores",
            "VALUES-PLACEHOLDER": "Seleccione los valores.",
            "X-LABEL": "Rótulo del eje X",
            "X-LABEL-PLACEHOLDER": "Escriba aquí el rotulo del eje X.",
            "X-VALUES": "Valores de X",
            "X-VALUES-PLACEHOLDER": "Seleccione los valores.",
            "Y-LABEL": "Rótulo del eje Y",
            "Y-LABEL-PLACEHOLDER": "Escriba aquí el rotulo del eje Y.",
            "Y-VALUES": "Valores de Y",
            "Y-VALUES-PLACEHOLDER": "Seleccione los valores.",
            "RESET-VALUES": "Restablecer valores",
            "SELECT-VALUES": "Seleccionar valores",
            "SERIES-NAME": "Nombre de la serie",
            "SERIES-NAME-PLACEHOLDER": "Escriba aquí el nombre de la serie.",
            "NEW-SERIES-BTN": "Agregar serie",
            "REMOVE-SERIES-HOVER": "Eliminar serie por completo"
        },
        "LOBF": {
            "HIDE": "Ocultar recta de ajuste óptimo",
            "SHOW": "Mostrar recta de ajuste óptimo",
            "DRAW": "Dibujar recta de ajuste óptimo"
        }
    },
    "REPORTS": {
        "DIALOGS": {
            "TYPE": {
                "WARNING": "Warning",
                "INFO": "Information",
                "CONFIRM": "Please confirm"
            },
            "ERRORS": {
                "NO-EXPORT-DATA": "There is no data to be exported"
            }
        },
        "TABS": {
            "ANOMALIES": "By Anomaly",
            "CORRUPTED-FILES": "By Corrupted Files"
        },
        "TOOLTIPS": {
            "BUTTONS": {
                "EXPORT-BTN": "Export as Excel Sheet",
                "REFRESH-BTN": "Refresh view"
            }
        },
        "ANOMALIES": {
            "LIST": {
                "TITLE": "Response File Anomaly Report",
                "SEARCH": "Search:",
                "FILTER": "Filters:",
                "SESSION": "Session:",
                "LEGEND": {
                    "ALREADY-SUBMITTED": "Additional file received after submission",
                    "RESPONSEFILE-IN-ABSENCE": "File received after flagged absent",
                    "BEFORE-TIMEFRAME": "Early submission",
                    "AFTER-TIMEFRAME": "Late submission",
                    "FOCUS-LOST": "Focus Lost",
                },
                "GRID": {
                    "REASON": "Flag",
                    "PAPER-CODE": "Paper Code",
                    "PAPER-NAME": "Paper Name",
                    "CANDIDATE-NAME": "Candidate",
                    "CANDIDATE-LASTNAME": "Candidate last name",
                    "CANDIDATE-FIRSTNAME": "Candidate first name",
                    "CANDIDATE-NUMBER": "Candidate Number",
                    "SCHOOL-CODE": "School Code",
                    "RESPONSE-FILE": "Response Filename",
                    "ACTIONS": {
                        "OPEN-REPORT": "Open"
                    }
                },
                "TOOLTIP": {
                    "SCHOOL-NAME": "School:",
                    "ASSESSMENT-TIMEFRAME": "Assessment's time frame:",
                    "RESPONSE-TIME": "Additional submission:",
                    "SUBJECT": "Subject:",
                    "SUBMITTED-ON": "First Submission:"
                },
                "REMOVE-FILTERS-BTN": "Remove all filters"
            }
        },
        "CORRUPTED-FILES": {
            "LIST": {
                "TITLE": "Corrupted Response Files Report",
                "SEARCH": "Search:",
                "LEGEND": {
                    "VIRUS": "Virus",
                    "CORRUPTED-ZIP": "Corrupted Zip file",
                    "ZEROBYTE": "File with Zerobytes",
                    "UNIDENTIFIED-CASE": "Unidentified case"
                },
                "GRID": {
                    "RESPONSE-FILE": "Filename",
                    "DATE-TIME": "Date/Time Received",
                    "RESULT": "Result"
                },
                "RESULTS": {
                    "VIRUS": "Virus",
                    "CORRUPT-ZIP": "Corrupted Zip File",
                    "ZEROBYTE": "Zero bytes"
                },
                "REMOVE-FILTERS-BTN": "Remove all filters"
            }
        }
    },
    "ADMIN-UI": {
        "ASSESSMENT": {
            "TOOLTIPS":{
                "REMOVE-FILTERS-BTN": "Eliminar filtros",
                "REMOVE-FILTER-BTN": "Eliminar filtro",
                "EXPORT-BTN": "Exportar",
                "REFRESH-BTN": "Refrescar"
            },
            "LIST": {
                "SHOW-STATISTICS": "Mostrar estadísticas",
                "TITLE": "Consola de administración: códigos de examen",
                "TITLE-ASSESSMENT": "Examination List",
                "TITLE-SCHOOL": "Lista de colegios",
                "GRID": {
                    "TITLE": "Título",
                    "SUBJECT": "Asignatura",
                    "PAPER-CODE": "Código de la prueba",
                    "LANGUAGE": "Lengua",
                    "SCHOOL-NAME": "Nombre del colegio",
                    "SCHOOL-CODE": "Código del colegio",
                    "SESSION": "Convocatoria",
                    "PROGRAMME": "Programa",
                    "CANDIDATES-REGISTERED": "Alumnos (matriculados)",
                    "RESPONSES-RECEIVED": "Archivos de respuestas recibidos",
                    "RESPONSES-OUTSTANDING": "Respuestas pendientes",
                    "SUBMISSIONS": "Envíos",
                    "SUBMISSIONS-OUTSTANDING": "Envíos pendientes",
                    "SUBMISSIONS-ABSENT": "Total de enviados como ausentes",
                    "TOTAL-SCHOOLS": "Total Schools",
                    "TOTAL-FILES-UNMATCHED": "Total Response Files Unmatched",
                    "TOTAL-INCIDENTS": "Total Incidents",
                    "ACTIONS": {
                        "OPEN-SCHOOL-LIST": "Abrir lista de colegios",
                        "OPEN-ASSESSMENT-DETAIL": "Abrir detalle"
                    }
                },
                "SELECT-DEFAULT": {
                    "SUBJECT": "Seleccionar asignatura",
                    "LANGUAGE": "Seleccionar lengua",
                    "SESSION": "Seleccionar convocatoria"
                },
                "FILTER": "Filtrar",
                "FILTERS": {
                    "NO-RESPONSE-FILE": "No se ha cargado ningún archivo de respuestas.",
                    "ALL-RESPONSE-FILE": "Se han cargado todos los archivos de respuestas.",
                    "MISSING-RESPONSE-FILE": "Faltan algunos archivos de respuestas.",
                    "NO-DOWNLOADS": "Todavía no se ha realizado ninguna descarga.",
                    "NO-SUBMISSIONS": "Todavía no se han realizado envíos.",
                    "ALL-SUBMISSIONS": "Se han completado todos los envíos.",
                    "MISSING-SUBMISSIONS": "Faltan algunos envíos."
                },
                "SEARCH": "Buscar",
                "PLACEHOLDER": {
                    "SCHOOL-NAME": "Nombre del colegio",
                    "SCHOOL-CODE": "Código del colegio"
                },
                "SELECTED-FILTER":"Selected Filters",
                "FILTER-TEXT": {
                    "statistics":          "Statistics",
                    "search":              "Search <strong>\"{{s}}\"</strong>",
                    "subject":             "Subject <strong>\"{{s}}\"</strong>",
                    "language":            "Language <strong>\"{{s}}\"</strong>",
                    "session":             "Session <strong>\"{{s}}\"</strong>",
                    "school_code":         "School-Code <strong>\"{{s}}\"</strong>",
                    "school_name":         "School-Name <strong>\"{{s}}\"</strong>",
                    "no_downloads":        "No downloads yet",
                    "no_responses":        "No response files uploaded",
                    "all_responses":       "All response files uploaded",
                    "missing_responses":   "Missing response files",
                    "no_submissions":      "No submissions yet",
                    "all_submissions":     "All submissions complete",
                    "missing_submissions": "Missing submissions"
                }
            },
            "DETAIL": {
                "TITLE": "Examen",
                "SEARCH": "Buscar alumnos",
                "SUBMISSIONS-COMPLETE": "Se han completado todos los envíos correspondientes a este examen.",
                "PIRATE-FILES-INFO": "Se han recibido <span class=\"label label-danger\"><strong>{{ pirate_response_files_count }}</strong> archivos de respuestas </span> que no se pudieron emparejar automáticamente con un alumno matriculado. <br><br>Empareje estos archivos de respuestas manualmente.",
                "UPLOAD-DONE": "Carga de archivos completada.",
                "UPLOAD-CONFIRM-MESSAGE-DONE": "Todos los archivos de respuesta se han cargado correctamente.<br><br>Tenga en cuenta que el procesamiento de los archivos de respuestas puede durar de una a tres horas.",
                "UPLOAD-CONFIRM-MESSAGE-ERROR": "Se ha presentado un problema. Algunos archivos no se han cargado: <br>",
                "FILTERS": {
                    "MISSING-RESPONSE": "Sin archivos de respuestas",
                    "INCIDENTS-LOGGED": "Incidentes registrados",
                    "IGNORE-SUBMITTED": "Ocultar los alumnos enviados"
                },
                "CANDIDATE-LIST": {
                    "TITLE": "Alumnos",
                    "INFO-PANELS": {
                        "NO-RESPONSE": "No se ha recibido el archivo de respuestas.",
                        "RESPONSE-RECEIVED": "Archivo de respuestas recibido el {{ received_on }}.",
                        "ONE-OPEN-INCIDENT": "Hay un incidente abierto.",
                        "MULTIPLE-OPEN-INCIDENTS": "Hay {{ count }} incidentes abiertos.",
                        "SUBMITTED_ON": "Enviado al IB",
                        "RESPONSE-FILES-RECEIVED": "{{count}} El archivo de respuestas se ha recibido y se está procesando en este momento",
                        "RESPONSE-FILES-SUCCESS": "{{count}} El archivo de respuestas se ha procesado correctamente y está listo para enviar",
                        "DUPLICATE-RESPONSE-FILES": "{{count}} duplicate response files received",
                        "FILE-NAME": "Nombre del archivo",
                        "RESPONSE-BLANK": "Este archivo de respuestas no contiene ninguna respuesta del alumno."
                    },
                    "TOOLTIP":{
                        "DUPLICATE-RECEIVED-FILE":"Se ha recibido un archivo de respuestas duplicado"
                    },
                    "CAPTURED-INCIDENTS": {
                        "TITLE": "Incidentes registrados",
                        "INCIDENT": "Incidente",
                        "TIME": "Hora",
                        "NOTE": "Nota",
                        "ADD-NOTE": "Agregar nota"
                    },
                    "CAPTURE-NEW-INCIDENT": "Registrar nuevo incidente",
                    "SUBMIT-TO-IB": "Enviar al IB",
                    "SUBMITTED-TO-IB": "Enviado al IB",
                    "UNSUBMIT-CANDIDATE": "Marcar como no enviado",
                    "ATTENDANCE_PREFIX": "Asistencia",
                    "CHECK-HYBRID-RESPONSE-BTN": "Intentar recuperar las respuestas en línea"
                },
                "ACTIONS": {
                    "SELECT-ALL": "Seleccionar todos",
                    "SUBMIT-SELECTED": "Enviar los seleccionados",
                    "ADD-GLOBAL-NOTE": "Aplicar nota global",
                    "ADD-NEW-GLOBAL-INCIDENT": "Crear incidente global"
                },
                "STATISTICS": {
                    "CANDIDATES-REGISTERED": "Alumnos matriculados: {{ count }}",
                    "CANDIDATES-WITH-RESPONSES": "Alumnos con archivo de respuestas: {{ count }}",
                    "POTENTIAL-PIRATES": "Alumnos no matriculados con anterioridad: {{ count }}",
                    "DROP-FILES": "Coloque aquí los archivos de respuestas.",
                    "UPLOAD-FILES": "Cargar {{ count }} archivos",
                    "UNMACHTED-RESPONSES": "Emparejar los archivos de respuestas manualmente",
                    "FILE-REJECTED": "Se ha rechazado un archivo.",
                    "FILES-REJECTED": "Se han rechazado {{ count }} archivos.",
                    "CANDIDATES-ABSENT": "Alumnos declarados ausentes: {{ count }}"
                },
                "CHART": {
                    "NOT-SUBMITTED": "No enviados todavía",
                    "SUBMITTED": "Enviados",
                    "SUBMITTED-TITLE": "Archivos de respuestas enviados",
                    "CANDIDATES-ABSENT": "Alumnos ausentes",
                    "RESPONSE-RECEIVED-TITLE": "Archivos de respuestas recibidos",
                    "RESPONSE-RECEIVED": "Con archivo de respuestas",
                    "RESPONSE-MISSING": "Sin archivo de respuestas"
                },
                "ORDERBY": {
                    "PREFIX": "Ordenar por",
                    "FIRST-NAME": "Nombre",
                    "LAST-NAME": "Apellido(s)",
                    "CANDIDATE-CODE": "Código del alumno"
                },
                "DIALOG": {
                    "INCIDENT": {
                        "HEADER": "Detalles del incidente",
                        "TITLE": "Incidentes registrados <span class=\"small\">para</span>",
                        "TITLE-GLOBAL-INCIDENT": "Nota global",
                        "TITLE-NEW-GLOBAL-INCIDENT": "Incidente global",
                        "PANEL-TITLE": "Alumnos",
                        "INCIDENT-EXPLAINS-OTHER": "Este incidente explica otros incidentes registrados para el alumno.",
                        "CANDIDATE-NAME": "Nombre del alumno",
                        "CANDIDATE-DATE-OF-BITH": "Fecha de nacimiento",
                        "CANDIDATE-CODE": "Código del alumno",
                        "CAPTURED-INCIDENT": "Adjuntar nota del incidente",
                        "INCIDENT-TYPE": "Tipo de incidente",
                        "INCIDENT-TYPE-PLACEHOLDER": "-- Seleccionar tipo de incidente --",
                        "INCIDENT-REASON-PLACEHOLDER": "-- Seleccionar motivo  --",
                        "DESCRIPTION": "Descripción",
                        "EXPLANATORY-NOTE-CAPTURED": "¿Se registró la nota explicativa?",
                        "EXPLANATORY-NOTE-PLACEHOLDER": "Introduzca una nota explicativa.",
                        "EXPLAINED-BY": "Se explica en el incidente anterior",
                        "ATTACH-GLOBAL-NOTE": "Adjuntar nota global",
                        "INCIDENTS-NOT-EXISTS": "No hay incidentes abiertos que requieran una nota explicativa. No puede agregar una nota global.",
                        "CANCEL": "Cancelar",
                        "SAVE": "Guardar",
                        "SELECT-ALL":"Seleccionar todos",
                        "DESELECT-ALL":"Seleccionar todos",
                        "ERROR-DIALOG-HEADLINE":"Lo sentimos!",
                        "ERROR-DIALOG-MESSAGE":"Hay un problema técnico que le impide guardar esta nota.<br>Estamos trabajando para resolver el problema. Disculpe las molestias.<br>Le mandaremos un correo con más información lo antes posible."
                    },
                    "MATCHED-RESPONSE-FILES": {
                        "SUCCESS": "el archivo de respuestas se ha emparejado correctamente."
                    },
                    "UNMATCHED-RESPONSE-FILES": {
                        "TITLE": "Archivos de respuestas sin correspondencia",
                        "SEARCH": "Buscar",
                        "CONTENT": "Hemos detectado <span class=\"badge\">{{ pirate_response_files_count }}</span> archivos de respuestas que no están emparejados con ningún alumno. <br><br> Seleccione a la izquierda un archivo de respuestas y emparéjelo con uno de los alumnos que aparecen a la derecha.",
                        "CANDIDATE-NUMBER": "Código del alumno",
                        "MISSING-RESPONSE": "Archivos de respuestas no recibidos",
                        "UNMATCHED": "Archivos de respuestas sin correspondencia",
                        "MATCH-TO": "Emparejar",
                        "SELECT-CANDIDATE": "Emparejar con el alumno",
                        "INFO": "Seleccione un archivo de respuestas para emparejarlo con un alumno.",
                        "CLOSE": "Cerrar",
                        "CONFIRM": "Confirmar",
                        "CONFIRM-TITLE": "Confirmar",
                        "CONFIRM-MESSAGE": "¿Está seguro de que desea emparejar? <br><br>Archivo de respuestas: <strong>{{ response_file }}</strong> <br><br>con <br><br>Alumno matriculado: <strong>{{ candidate }}</strong>",
                        "UNMATCHED-CONFIRM-BTN": "Desparejar archivos de respuestas de alumnos no matriculados con anterioridad",
                        "UNMATCHED-CONFIRM-MESSAGE": "¿Está seguro de que desea desparejar? <br><br>Archivo de respuestas: <strong>{{ response_file }}</strong> <br><br>y <br><br>Alumno matriculado: <strong>{{ candidate }}</strong><br><br> El archivo de respuestas volverá a aparecer como \"archivo de respuestas sin correspondencia\"."
                    },
                    "HYBRID-RESPONSE-FILES":{
                        "TITLE": "Recuperar respuestas en línea",
                        "TABLE":{
                            "HEADER":{
                                "SESSION-ID": "Identificación de la convocatoria",
                                "SESSION-LIFETIME": "Duración de la sesión",
                                "TIME-ELAPSED":"Tiempo transcurrido"
                            }
                        },
                        "SESSION-LIFETIME-UNKNOWN": "Desconocida",
                        "CLOSE":"Cerrar",
                        "IS-RESTORED":"ha sido recuperada",
                        "CANCEL":"Cancelar",
                        "RESTORE":"Recuperar",
                        "SELECT":"Seleccionar",
                        "HAS_BEEN_RESTORED": " fue recuperado y se procesará pronto.",
                        "NO-SESSIONS-FOUND": "No se encontraron respuestas en línea."
                    },
                    "SUBMIT-WITH-ONLY-BLANK-RESPONSES":{
                        "HEADER": "Advertencia",
                        "MESSAGE": "Todos los archivos de respuestas recibidos de este alumno están vacíos. <br/> Si cree que el alumno no respondió a las preguntas durante el examen, envíe los archivos. <br/>En caso contrario, póngase en contacto con el IB.",
                        "BTN-SUBMIT": "Enviar respuesta vacía",
                        "BTN-CANCEL": "Cancelar"
                    },
                    "SUBMIT-SELECTED-WITH-BLANK-RESPONSES":{
                        "HEADER": "Warning",
                        "MESSAGE": "{{count_successfully}} files submitted successfully, {{count_blank}} files not submitted as they were found to be blank. Please submit these individually if necessary.",
                        "BTN-SUBMIT": "Ok",
                        "BTN-CANCEL": "Cancel"
                    },
                    "SUBMIT-WITH-ATTENDANCE-ABSENT":{
                        "HEADER": "Warning",
                        "MESSAGE": "This candidate has a response file, but is also flagged as absent and therefore did not sit the assessment.<br/>Please change their attendance status and resubmit, or contact the IB for further assistance if that is not suitable.",
                        "BTN-SUBMIT": "Ok",
                        "BTN-CANCEL": "Cancel"
                    }
                }
            }
        },
        "AUTH": {
            "REGISTRATION": "Registro",
            "SAVE": "Guardar",
            "LOGIN-FAILED": "Datos de acceso inválidos"
        },
        "PROGRESS": {
            "LOGGED_IN": "Logged in",
            "SCHOOL_DATA": "Reading school data"
        },
        "MODEL": {
            "CANDIDATEATTENDANCE": {
                "ABSENT": "Ausente",
                "ATTENDED": "Presente",
                "UNKNOWN": "Desconocida"
            },
            "CANDIDATEREGISTRATION": {
                "FULLNAME": "{{ first_name}} {{ last_name }}",
                "TOSTRING": "{{ fullname }}, {{ date }}, {{ number }}"
            }
        },
        "LOGIN": {
            "HEADLINE": "Consola de administración",
            "LABELS"  : {
                "LANGUAGE"         : "Seleccionar lengua",
                "INVIGILATOR-CODE" : "Código de supervisor",
                "ADMIN-ACCESS-CODE": "Código para la consola de administración"
            },
            "CONTENT"    : {
                "LOGGED-HEADLINE" : "Ha iniciado sesión.",
                "NOT-LOGGED": "No ha iniciado sesión.",
                "LOGGED": "Esta es la pantalla de inicio. Utilice el menú que aparece en la esquina superior izquierda para navegar."
            },
            "LOGIN-BTN": "Iniciar sesión"
        },
        "COMPCHECK": {
            "LIST-POPOVER-TITLE": "Compatibility Check Results ({{count}})",
            "LIST-POPOVER":       "Failed:{{results.failed}}, Warning:{{results.warning}}, Passed:{{results.passed}}",
            "LIST":               {
                "TITLE": "Compatibility Check Results",
                "GRID": {
                    "COMPUTER-NAME":           "Computer-Name",
                    "TSTAMP":                  "Created",
                    "TOTAL-COMPCHECKRESPONSE": "# Responses",
                    "TOTAL-COMPCHECKRESULTS":  "# Test Results",
                    "RESULT":                  "Result",
                    "RESULT-FAILED":           "# Failed",
                    "RESULT-WARNING":          "# Warning",
                    "RESULT-PASSED":           "# Passed",
                    "TIME":                    "Time Taken",
                    "NAME":                    "User-Name",
                    "EMAIL":                   "E-Mail"
                }
            },
            "FILTER":             {
                "RESULT-LABEL":   "Filter",
                "SEARCH-LABEL":   "Search",
                "DEFAULT-FILTER": "All"
            },
            "RESULT-DETAILS":     {
                "HEADLINE":                 "Results Details",
                "PANEL-TITLE":              {
                    "PASSED":  "Passed",
                    "FAILED":  "Failed",
                    "WARNING": "Warning"
                },
                "TAB-HEADLINE":             {
                    "USER-INPUT": "User Input",
                    "SELF-TEST":  "Self Test",
                    "USER-TEST":  "User Test"
                },
                "TIME":                     "Time:",
                "TIME-VALUE":               "{{time}}s",
                "FAIL-MESSAGE":             "Fail-Message:",
                "UNEXPECTED-ERROR-MESSAGE": "Unexpected Error Message:",
                "DATA":                     "Data",
                "LANGUAGE-DATA":            "Language-Data"

            },
            "RESULT-STATUS":      {
                "PASSED":  "Passed",
                "FAILED":  "Failed",
                "WARNING": "Warning"
            },
            "ERROR":              {
                "REQUEST": {
                    "TITLE":   "Request Error",
                    "MESSAGE": "Server Message: {{error}}"
                }
            }
        }
    },
    "COLOR-THEME": {
        "DEFAULT": "Predeterminado",
        "LIGHT-YELLOW": "Amarillo claro",
        "BLUE": "Azul",
        "YELLOW": "Amarillo",
        "PINK": "Rosado",
        "GREY": "Gris",
        "OFF-WHITE": "Blanquecino",
        "BLACK": "Negro"
    },
    "COMCHECK": {
        "INFO": {
            "REQUIRED-INFO": "El campo marcado con un asterisco debe completarse."
        },
        "AUDIO-COMP-CHECK": {
          "DESCRIPTION": [
            "El archivo de audio que aparece a continuación debe empezar automáticamente. Verifique que hay sonido y es claro.",
            "Indique si esta comprobación tuvo éxito o falló para avanzar automáticamente al paso {{nextStep}}."
          ],
          "FAILED-BTN": "Insuficiente",
          "FAILED-MSG": "Ha indicado que el archivo de audio no se reprodujo correctamente.",
          "LABEL": "Comprobación del audio",
          "SUCCESS-BTN": "Adecuado"
        },
        "BTN": {
          "CANCEL": "Cancelar",
          "CLOSE": "Cerrar",
          "CONTINUE": "Avanzar al paso {{nextStep}}",
          "QUIT": "Salir",
          "REMOVE": "Eliminar",
          "RETRY": "Reintentar carga"
        },
        "KEYBOARD-LAYOUT-COMP-CHECK": {
          "KEYBOARD": "Teclado",
          "ACTIVATE-CHECKER": "",
          "ACTIVATE-CHECKER-BTN": "Sí",
          "ACTIVATE-CHECKER-LANG": {
            "ARABIC": "Árabe",
            "KOREAN": "Coreano",
            "MANDARIN_CN": "Chino (caracteres simplificados)",
            "MANDARIN_TW": "Chino (caracteres tradicionales)"
          },
          "ADD-LANG-BTN": "Añadir una lengua",
          "CKEDITOR": {
            "PLACEHOLDER": "Escriba algo en {{lang}}"
          },
          "CONTINUE-TEST-BTN": "Continuar con la verificación",
          "DEACTIVATE-CHECKER-BTN": "No",
          "DESCRIPTION_1": [
            "¿Va a utilizarse este dispositivo para realizar alguno de los exámenes en pantalla de Lengua y Literatura indicados a continuación?"
          ],
          "DESCRIPTION_2": [
            "Indique para qué exámenes de Lengua y Literatura se utilizará este dispositivo y haga clic en <strong>Continuar con la verificación</strong>."
          ],
          "DESCRIPTION_3": [
            "En este paso se probarán el teclado y el método de entrada para asegurar que funcionan correctamente.",
            "Escriba algo en los cuadros correspondientes a continuación.",
            "Esta prueba deberá realizarse en todos los idiomas que vayan a utilizarse en este dispositivo."
          ],
          "FAILED-BTN": "Insuficiente",
          "FAILED-MSG": "<p>Ha indicado que el resultado de la comprobación de la distribución del teclado y el método de entrada no ha sido el esperado para este idioma.</p><p>Compruebe que el dispositivo tenga instalados el teclado y las fuentes requeridos y, si necesita más asistencia, póngase en contacto con el IB.</p>",
          "INSTRUCTION": {
            "CHANGE-KEYBOARD-LAYOUT": "Haga clic en este icono para cambiar la distribución del teclado y el método de entrada actuales. Debe seleccionar la distribución del teclado y el método de entrada adecuados al idioma que esté probando.",
            "SELECT-LANG": "",
            "TESTING-SELECTED-LANG": [
              "Indique si las comprobaciones se han superado o han fallado utilizando los botones correspondientes. Debe indicar que la prueba ha <strong>\"fallado\"</strong> si el texto en el cuadro no se muestra correctamente o presenta algún otro problema. ",
              "Una vez completado, avance al paso {{nextStep}}."
            ]
          },
          "LABEL": "Distribución del teclado",
          "MODAL": {
            "HEADER": "Error",
            "INFO": "Debe indicar manualmente si se ha superado la comprobación de compatibilidad de la distribución del teclado en todos los idiomas o ha fallado. Todavía no hay resultados para los idiomas siguientes:",
            "RESULT-ERROR": "{{langName}}"
          },
          "NO-LANGUAGES": "Ningún idioma seleccionado",
          "SUCCESS-BTN": "Adecuado"
        },
        "LABEL": "Comprobador de compatibilidad del examen en pantalla",
        "LANGUAGE-SELECTION": {
          "LABEL": "Seleccionar lengua",
          "LANGUAGE": {
            "ENGLISH_US": "English",
            "FRENCH_FR": "Français",
            "SPANISH_ES": "Español"
          },
          "LANGUAGE-PLACEHOLDER": "Please select your language / Veuillez sélectionner votre langue / Seleccione el idioma"
        },
        "QUIT-MODAL": {
          "HEADER": "Salir del examen",
          "INFO": [
            "¿Está seguro de que desea salir de la comprobación de compatibilidad?",
            "Haga clic en <strong>Cancelar</strong> para volver.",
            "Preparación de los resultados",
            "Preparando las respuestas."
          ]
        },
        "STEP": "Paso {{currentStep}} de {{maxSteps}}",
        "SUMMARY-COMP-CHECK": {
          "LABEL": "Resumen de los resultados",
          "PANEL-HEADER": {
            "ABORTED-TESTS": "Pruebas canceladas",
            "FAILED": "Insuficiente",
            "PASSED": "Adecuado",
            "WARNING": "Advertencia"
          },
          "STATUS-PANEL-DESCRIPTION": {
            "FAILED": [
              "Este dispositivo no cumple los requisitos mínimos, al menos, en una categoría o ha experimentado un problema al reproducir el contenido. Por lo tanto, en su estado actual, no se puede utilizar para ejecutar exámenes en pantalla. Póngase en contacto con el IB para discutir los problemas que se deriven de esta comprobación de compatibilidad.",
              "Asegúrese de que estas comprobaciones se realicen en todos los dispositivos que se utilicen en los exámenes en pantalla."
            ],
            "PASSED": [
              "Este dispositivo cumple o supera todos los requisitos recomendados del sistema para que el usuario tenga una experiencia óptima. ",
              "Asegúrese de que estas comprobaciones se realicen en todos los dispositivos que se utilicen en los exámenes en pantalla."
            ],
            "WARNING": [
              "Este dispositivo cumple o supera todos los requisitos mínimos del sistema. Sin embargo, al menos en un caso no se ha cumplido el requisito recomendado. El dispositivo ejecutará los exámenes en pantalla, pero existe la posibilidad de que los usuarios no tengan una experiencia óptima.",
              "Asegúrese de que estas comprobaciones se realicen en todos los dispositivos que se utilicen en los exámenes en pantalla."
            ]
          },
          "STATUS-PANEL-HEADER": {
            "FAILED": "La comprobación de compatibilidad falló.",
            "PASSED": "La comprobación de compatibilidad se realizó correctamente.",
            "WARNING": "La comprobación de compatibilidad se realizó correctamente, aunque con advertencias."
          }
        },
        "SYSTEM-COMP-CHECK": {
          "COUNT": "{{currentTestNum}} de {{testCount}}",
          "LABEL": "Comprobación del sistema",
          "STATUS": {
            "FAILED": "Insuficiente",
            "PASSED": "Adecuado",
            "PROCESSING": "Procesando...",
            "WARNING": "Advertencia"
          },
          "STATUS-COUNT": {
            "FAILED": "Insuficiente {{count}}",
            "PASSED": "Adecuado {{count}}",
            "WARNING": "Advertencia {{count}}"
          },
          "STATUS-MESSAGE": {
            "FAILED": "Este dispositivo no cumple los requisitos mínimos de esta comprobación. El examen en pantalla no se ejecutará, ya que la experiencia del usuario podría verse afectada significativamente.",
            "PASSED": "Este dispositivo cumple o supera los requisitos recomendados de esta comprobación.",
            "PROCESSING": "Procesando...",
            "WARNING": "Este dispositivo no cumple los requisitos recomendados, pero cumple los requisitos mínimos de esta comprobación. El examen en pantalla se ejecutará, pero la experiencia del usuario podría no ser óptima."
          },
          "TEST-NAME": {
            "DiskSpace": "Comprobación de espacio en el disco",
            "InternetConnection": "Conectividad a Internet",
            "MediaServerTest": "Prueba del servidor multimedia",
            "OSVersion": "Versión del sistema operativo",
            "ScreenRes": "Comprobación de resolución de pantalla",
            "SysMem": "Comprobación de memoria del sistema",
            "VmDetection": "Prueba en máquina virtual",
            "WriteResponse": "Comprobación de que se puede guardar el archivo de respuestas en este dispositivo"
          }
        },
        "UPLOAD-STATUS": {
          "MSG": {
            "PACK-RESPONSE-FAILED": "Pack Response Failed",
            "PACK-RESPONSE-SUCCESS": "Pack Response success",
            "RESPONSE_INITIALIZED": "Response Initialized",
            "RESPONSE_INIT_FAILED": "Response Init failed",
            "UPLOAD-CONFIG-MISSING": "Upload Config missing",
            "UPLOAD-INTERNET-CONNECTION": "Fallo en la conexión a Internet",
            "UPLOAD-SUCCESS": "Los resultados se han enviado correctamente al IB.",
            "USER-DATA-EMPTY": "User data is empty",
            "RESPONSE-READY": " Tratamiento completo. Ahora puede <strong>Salir</strong>."
          },
          "TYPE": {
            "INIT": "Iniciando carga de resultados",
            "PACK-RESPONSE": "Intercalando datos",
            "UPLOAD": "Enviando resultados al IB",
            "UPLOAD-PROGRESS": "[Upload Progress]",
            "OFFLINE-INIT": "Procesando"
          }
        },
        "USER-DATA": {
          "DESCRIPTION": [
            "El comprobador de compatibilidad verificará si el dispositivo cumple con los requisitos básicos para ejecutar paquetes de exámenes en pantalla.",
            "Introduzca la información que se indica a continuación y vaya al paso {{nextStep}}.",
            "El IB registrará los resultados de esta comprobación, por lo que es importante introducir correctamente el código del colegio."
          ],
          "ERROR": {
            "REQUIRED-SCHOOL-CODE": "Introduzca su código de colegio.",
            "VALID-MAIL": "La dirección de correo electrónico no es válida.",
            "VALID-SCHOOL-CODE": "El código del colegio debe contener seis dígitos, y puede ir precedido por ceros si es necesario (por ej., 001234)."
          },
          "INPUT-LABEL": {
            "EMAIL": "Dirección de correo electrónico",
            "NAME": "Nombre",
            "SCHOOL-CODE": "Código del colegio"
          },
          "LABEL": "Datos del usuario"
        },
        "VIDEO-COMP-CHECK": {
          "DESCRIPTION": [
            "El archivo de video que aparece a continuación debe empezar a reproducirse automáticamente. Verifique que el video se está reproduciendo y que la imagen y el sonido son claros.",
            "Indique si esta comprobación tuvo éxito o falló para avanzar automáticamente al paso {{nextStep}}."
          ],
          "FAILED-BTN": "Insuficiente",
          "FAILED-MSG": "Ha indicado que el video no se reprodujo correctamente.",
          "LABEL": "Comprobación del video",
          "SUCCESS-BTN": "Adecuado"
        }
    },
    "SPECIMEN-RESPONSE-UPLOAD": {
        "LABEL": "Carga de respuestas de los alumnos",
        "FILENAME": "Nombre de archivo",
        "BUTTON-CLOSE-SESSION": "Cerrar sesión",
        "LOGIN": {
            "LABEL" : "Iniciar sesión",
            "ENTER-PASSWORD": "Ingrese contraseña:",
            "INVALID-LOGIN": "<strong>Ha ingresado una contraseña incorrecta. Inténtelo de nuevo.</strong>"
        },
        "SESSION": {
            "TITLE": "Carga de archivos de respuestas del IB",
            "EXPIRED": "Su sesión ha caducado.",
            "EXPIRED-TRY-AGAIN": "Vuelva a iniciar sesión para cargar más archivos de respuestas.",
            "ERROR": "Hay un problema con su sesión.",
            "ERROR-TRY-AGAIN": "Vuelva a iniciar sesión para cargar más archivos de respuestas."
        },
        "IDENTIFICATION": {
            "LABEL" : "Identificación",
            "FORM": {
                "NAME": "Ingrese su nombre:",
                "EMAIL": "Ingrese su dirección de correo electrónico:",
                "EMAIL-CONFIRM": "Confirme su dirección de correo electrónico:",
                "SCHOOLCODE": "Ingrese su código de colegio:",
                "BUTTON-CONFIRM": "Confirmar"
            },
            "FORM-PLACEHOLDER": {
                "NAME": "Nombre",
                "EMAIL": "Dirección de correo electrónico",
                "SCHOOLCODE": "Código del colegio"
            },
            "FORM-VALIDATION": {
                "NAME": "Es obligatorio ingresar un nombre.",
                "EMAIL-REQUIRED": "Es obligatorio ingresar una dirección de correo electrónico válida.",
                "EMAIL-INVALID-FORMAT": "Es obligatorio ingresar una dirección de correo electrónico válida.",
                "EMAIL-DIVERGE": "Las direcciones de correo electrónico ingresadas no coinciden.",
                "SCHOOLCODE-REQUIRED": "Ingrese su código numérico de colegio.",
                "SCHOOLCODE-INVALID": "Ingrese su código numérico de colegio."
            },
            "INFO-BOX": {
                "MESSAGE": "El enlace de descarga del archivo PDF se enviará a la dirección de correo electrónico ingresada aquí."
            }
        },
        "UPLOAD": {
            "LABEL" : "Cargar",
            "UPLOAD-BOX": {
                "MESSAGE": "Arrastre aquí los archivos de respuestas o haga clic en ",
                "BUTTON-BROWSE": "Examinar",
                "ONLY-RESPONSE-FILES": "Añada solo archivos de tipo <strong>.ibresponse</strong>.",
                "REMAINING": {
                    "SINGLE-FILE": "1 archivo restante",
                    "MULTIPLE-FILES": "{{ files }} archivos restantes"
                }
            },
            "QUEUE-BOX": {
                "SELECTED-FILES": "Archivos seleccionados:",
                "REJECTED-FILES": "Archivos rechazados:",
                "BUTTON-UPLOAD": "Cargar"
            },
            "NO-IB-FILES": {
                "TITLE": "Carga de archivos de respuestas del IB",
                "MESSAGE": "Ha intentado cargar un tipo de archivo no válido. Todos los archivos que no sean .ibresponse se excluirán del procesamiento final."
            },
            "UPLOAD-DONE": "Carga completada",
            "UPLOAD-CONFIRM-MESSAGE-DONE": "Todos los archivos de respuestas válidos se han cargado correctamente.",
            "UPLOAD-CONFIRM-MESSAGE-DONE-ADDITIONAL": "En la página siguiente encontrará más información sobre el proceso de carga.",
            "UPLOAD-CONFIRM-MESSAGE-ERROR": "Advertencia. No se cargaron algunos archivos: <br>",
            "PROGRESS-BARS": {
                "OVERALL": "Cargando {{ s1 }}/{{ total }} archivo(s) .ibresponse"
            }
        },
        "PROGRESS": {
            "LABEL": "Progreso"
        },
        "SUMMARY": {
            "LABEL" : "Resumen",
            "NO-FILES": {
                "ATTEMPTED": "Ha intentado cargar {{ files }} archivos de respuestas.",
                "MESSAGE": "No se ha(n) podido cargar el (los) archivo(s) de respuestas.",
                "MORE-INFO": "Inténtelo de nuevo más tarde."
            },
            "SINGLE-FILE": {
                "ATTEMPTED": "Ha intentado cargar 1 archivo de respuestas.",
                "SUCCESS": "El archivo de respuestas se ha cargado correctamente.",
                "MORE-INFO": "Recibirá un mensaje de correo electrónico con el enlace para descargar el archivo PDF dentro de aproximadamente 30 a 60 minutos. El mensaje se enviará a {{ email }}."
            },
            "MULTIPLE-FILES": {
                "ATTEMPTED": "Ha intentado cargar {{ files }} archivo(s) de respuestas.",
                "SUCCESS": "Se han cargado <strong>{{ succededfiles }}</strong> archivos correctamente.",
                "MORE-INFO": "Recibirá un mensaje de correo electrónico con el enlace para descargar el archivo PDF dentro de aproximadamente 30 a 60 minutos. El mensaje se enviará a {{ email }}."
            },
            "REJECTED": {
                "TITLE": "Archivos rechazados:",
                "FILENAME": "Nombre de archivo"
            },
            "COULD-NOT-SAVE": "Hay un problema. Compruebe su conexión a Internet e inténtelo de nuevo."
        }
    },
    "NOT-AVAILABLE": "n/d",
    "DATE-FROM": "Desde:",
    "DATE-TO": "Hasta:",
    "TIMEZONE-UTC": "UTC",
    DIALOGS_ERROR: "Error",
    DIALOGS_ERROR_MSG: "Se ha producido un error desconocido.",
    DIALOGS_CLOSE: "Cerrar",
    DIALOGS_PLEASE_WAIT: "Espere.",
    DIALOGS_PLEASE_WAIT_ELIPS: "Espere...",
    DIALOGS_PLEASE_WAIT_MSG: "En espera del final de la operación",
    DIALOGS_PERCENT_COMPLETE: "% completado",
    DIALOGS_NOTIFICATION: "Notificación",
    DIALOGS_NOTIFICATION_MSG: "Notificación sobre aplicación desconocida",
    DIALOGS_CONFIRMATION: "Confirmación",
    DIALOGS_CONFIRMATION_MSG: "Se necesita confirmación.",
    DIALOGS_OK: "Aceptar",
    DIALOGS_YES: "Sí",
    DIALOGS_NO: "No"
}
